<template>
    <div class="steel-filters">
        <div class="steel-filters__container">
            <h3 class="steel-filters__title">
                {{ text.searchByName }}
            </h3>
            <div class="row">
                <div class="col-default-12">
                    <z-input
                        name="text"
                        v-model="formData.text"
                        @enter="send"
                        :placeholder="text.productName"
                        :value="formData.text"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-default-4 col-mobile-12">
                    <z-button
                        size="l"
                        @click="send"
                        class="steel-filters__button u-entire-width"
                    >{{ text.search }}</z-button>
                </div>
                <div class="col-default-3 col-default-offset-5 col-tablet-5 col-tablet-offset-3 col-mobile-12 col-mobile-offset-0">
                    <z-button
                        v-if="isClear"
                        size="s"
                        kind="close"
                        @click="clear"
                    >
                        {{ text.clear }}
                    </z-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'filters',
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        initial: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            formData: {
                text: '',
                type: this.initial['type']
            },
            text: {
                searchByName: localize({
                    ru: 'Поиск по наименованию',
                    en: 'Search by name'
                }),
                search: localize({
                    ru: 'Найти',
                    en: 'Search'
                }),
                clear: localize({
                    ru: 'Сбросить',
                    en: 'Clear'
                }),
                productName: localize({
                    ru: 'Название продукции',
                    en: 'Product name'
                })
            }
        }
    },
    mounted () {
        const params = new URL(document.location).searchParams
        this.formData.text = params.get('text') || ''

        if (this.formData.text !== '') {
            this.send()
        }
    },
    computed: {
        isClear () {
            return Boolean(this.formData.text)
        }
    },
    methods: {
        send () {
            this.$emit('search', this.formData)
        },
        clear () {
            this.formData.text = ''
            this.$emit('search', this.formData)
        }
    }
}
</script>

<style lang="scss">
.steel-filters {
    margin-top: $token-spacers-xl !important;
    margin-bottom: $token-spacers-xl;

    &__container {
        position: relative;
        border: 1px solid $token-colors-black-20;
        padding: $token-spacers-l;

      @include breakpoint(mobile) {
        padding: $token-spacers-xs;
      }
    }

    &__title {
        margin-top: 0;
        margin-bottom: $token-spacers-l;
    }

    &__button {
        &.z-button {
            min-width: 100%;
            height: 100%;
        }
    }

    .z-tabs-content {
        padding: 0;
    }
}
</style>
